var _path, _circle;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgSwap = function SvgSwap(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m12.158 15.465 9.509-6-5-1.465m4.509 8.535-9.51 6 5 1.465",
    stroke: "#16D629",
    strokeWidth: 2,
    strokeLinecap: "square",
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16.667,
    cy: 16,
    r: 15,
    stroke: "#16D629",
    strokeWidth: 2
  })));
};
export { SvgSwap as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzMiIGhlaWdodD0iMzIiIHZpZXdCb3g9IjAgMCAzMyAzMiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTEyLjE1NzggMTUuNDY0OEwyMS42NjY3IDkuNDY0MjRMMTYuNjY3MSA4TTIxLjE3NTYgMTYuNTM1MkwxMS42NjY3IDIyLjUzNThMMTYuNjY2MyAyNCIgc3Ryb2tlPSIjMTZENjI5IiBzdHJva2Utd2lkdGg9IjIiIHN0cm9rZS1saW5lY2FwPSJzcXVhcmUiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPGNpcmNsZSBjeD0iMTYuNjY2NyIgY3k9IjE2IiByPSIxNSIgc3Ryb2tlPSIjMTZENjI5IiBzdHJva2Utd2lkdGg9IjIiLz4KPC9zdmc+Cg==";